import { DetectorKind } from 'app/redux/flatPanelConfiguration/actions';
import { FlatPanelConfigurationState } from 'app/redux/flatPanelConfiguration/reducer';

export type Detector = any;

export enum PixRadSDKVersion {
  V9 = 9,
  V10 = 10,
}

type DetectorsConfigsTemplatesDir = string;
type DetectorsSavedConfigsDir = string;

type PixradDllPath = string;
type BaseRootDetectorConfigs = string;
type UserRootConfigDirectory = string;
type DetectorConfigRelativePath = string;

type GERParams = [DetectorsConfigsTemplatesDir, DetectorsSavedConfigsDir];
type PixRadParams = [
  PixRadSDKVersion,
  PixradDllPath,
  BaseRootDetectorConfigs,
  UserRootConfigDirectory,
  DetectorConfigRelativePath
];

type DetectorManagerInitParams = Record<DetectorKind, GERParams | PixRadParams>;

export interface DetectorManager {
  create(
    params: DetectorManagerInitParams & {
      config: FlatPanelConfigurationState;
    }
  ): DetectorManager | undefined;
  get(): DetectorManager | undefined;
  destroy(): void;
  scanOnce(): void;
  startScan(): void;
  stopScan(): void;
  getDetectors(): Record<string, Detector>;
  on(eventType: string, callback: (event: any) => void): void;
  once(eventType: string, callback: (event: any) => void): void;
  removeListener(eventType: string, callback: () => void): void;
}

export type XRayModuleType = {
  DetectorManager: DetectorManager;
};

const xray = (): XRayModuleType | undefined => window?.nodeModules?.xray;

export default xray;
